export function getQuotePdfFiles(files) {
    return Array.isArray(files) ? files.filter(({quotePdf}) => quotePdf) : [];
}

export function sortQuotePdfFilesByVersion(files) {
    return getQuotePdfFiles(files).sort((a, b) => (b.versionNumber ?? 0) - (a.versionNumber ?? 0));
}

export function getCurrentQuotePdf(files) {
    return sortQuotePdfFilesByVersion(files)[0] ?? null;
}
